import React, { useEffect } from "react";
import {
  Box,
  Flex,
  FormLabel,
  Heading,
  Icon,
  Input,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { closeAddSubjectAdmin, openShowSubjectAdminDataModel } from "../../../../modules/admin-modules/models/Actions";
import MainModel from "../../../../components/Models/main-model";
import { adminSelectStyles } from "../../../../components/Models/admin-modal-theme";
import { useForm } from "react-hook-form";
import MainInput from "../../../../components/Form/input";
import {
  createAdminSubjectRequest,
  editTeacherRequest,
} from "../../../../modules/admin-modules/teachers/Actions";
import { getAllGradesRequest } from "../../../../modules/admin-modules/grades/Actions";
import { getAllSubjectsRequest } from "../../../../modules/admin-modules/subjects/Actions";

const selectStyles = adminSelectStyles({ menuZIndex: 50 });

const AddSubjectAdmin = ({ isAdd, data, setSelectedData, setAddedSubjectAdmin }) => {
  const openTeacher = useSelector((state) => state.model.isOpen36);
  const dispatch = useDispatch();
  const subjects = useSelector((state) => state.subjects.subjects);
  const grades = useSelector((state) => state.grades.grades);
  const isLoading = useSelector((state) => state.teachers.isLoading);

  const gradesOptions = grades?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const subjectsOptions = subjects?.map((data) => {
    return { value: data.id, label: data.name };
  });

  useEffect(() => {
    if (openTeacher) {
      dispatch(getAllGradesRequest());
      dispatch(getAllSubjectsRequest());
    }
  }, [openTeacher]);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: data ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading textAlign="center" color="var(--text-primary)" fontSize="24px">
        {isAdd ? " إضافة مادة" : "تعديل  مادة"}
      </Heading>
    </Box>
  );
  const onSubmit = (data) => {
    const action = (responseData) => {
      dispatch(closeAddSubjectAdmin());
      setAddedSubjectAdmin && setAddedSubjectAdmin(responseData);
      dispatch(openShowSubjectAdminDataModel());
      setSelectedData({});
      reset();
    };
    if (isAdd) {
      let formData = new FormData();
      for (let key in data) {
        formData.append(key, data[key]);
      }
      dispatch(createAdminSubjectRequest(formData, action));
    } else {
      let formData = new FormData();
      for (let key in data) {
        formData.append(key, data[key]);
      }
      dispatch(
        editTeacherRequest({
          id: data?.id,
          formData: formData,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeAddSubjectAdmin());
    setSelectedData({});
    reset();
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openTeacher}
      buttonTitle={isAdd ? " إضافة مادة" : "تعديل  مادة"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={5} dir="rtl" w="100%">
          <Box w="55%">
            <MainInput
              label="اسم المادة"
              error={errors?.subject_name?.message}
              placeholder="ادخل اسم المادة"
              register={register}
              name="subject_name"
            />
          </Box>
          <Box w="55%">
            <MainInput
              label="اسم المادة بالعربية"
              error={errors?.subject_name_ar?.message}
              placeholder="ادخل اسم المادة بالعربية"
              register={register}
              name="subject_name_ar"
            />
          </Box>
          <Box w="55%">
            <MainInput
              label="رقم الموبايل"
              error={errors?.phone?.message}
              placeholder="اكتب رقم الموبايل"
              register={register}
              name="phone"
            />
          </Box>
          <Box w="55%">
            <FormLabel>الصف : </FormLabel>
            <Select
              options={gradesOptions}
              onChange={(data) => setValue("grade_id", data.value)}
              styles={selectStyles}
              placeholder="الصف"
            />
          </Box>
        </Stack>
      </form>
    </MainModel>
  );
};

export default AddSubjectAdmin;
